import { ColumnVisibility, Task } from 'src/lib/gantt-task-react/src';
import { Button } from 'antd';
import { StarFilled } from '@ant-design/icons';
import { DataType, DataTypeKeys, SectionKeys } from '../../../constant/index';
import { SectionIcon } from '../section_icon/section_icon';
import styles from './columns_list.module.scss';
import { WorkApi } from '../task_detail/use_work_details';

/**
 * スケジュールカラムの表示項目
 */
export interface CustomTask extends Task {
  /** 作業情報ID */
  workId: number;
  /** 作業計画ID */
  planId: number;
  /** 街区ID */
  divisionId: number;
  /** 街区 */
  division: string;
  /** フロアID */
  floorId: number;
  /** 階 */
  floor: string;
  /** 区画ID */
  blockId: number;
  /** 区画名 */
  block: string;
  /** 対象箇所 */
  target: string;
  /** 作業内容 */
  content: string;
  /** 業務データ種別 */
  businessDataType: DataTypeKeys;
  /** 作業区分コード */
  sections: SectionKeys[];
  /** 選択したデータ有無 */
  isSelected: boolean;
}

/**
 * スケジュールカラムの表示レイアウト
 * @param handleTask
 * @param isWorkChecked
 */
export function columnList(
  handleTask: (task: CustomTask) => void,
  isWorkChecked: boolean = true,
  isConflictListMark: boolean = false, // 「選択したデータ有無」欄を表示するか否か
): ColumnVisibility<CustomTask>[] {
  return [
    {
      columnName: '　',
      isVisible: isConflictListMark,
      width: '3em',
      columnWithArrow: true,
      toShow: () => { return (''); },
      render: (task: CustomTask) => {
        if (task.isSelected) {
          return (
            <div>
              <StarFilled />
            </div>
          );
        }
        return ('');
      },
    },
    {
      columnName: '詳細',
      isVisible: true,
      width: '5em',
      columnWithArrow: true,
      toShow: (task: CustomTask) => {
        return task.id;
      },
      render: (task: CustomTask) => {
        return (
          <div>
            <Button
              size={'small'}
              onClick={() => {
                handleTask(task);
              }}
            >
              詳細
            </Button>
          </div>
        );
      },
    },
    {
      columnName: 'workId',
      isVisible: false,
      width: '5em',
      toShow: (task) => {
        return task.workId.toString();
      },
    },
    {
      columnName: 'planId',
      isVisible: false,
      width: '5em',
      columnWithArrow: true,
      toShow: (task) => {
        return task.planId.toString();
      },
    },
    {
      columnName: '街区',
      isVisible: true,
      width: '7em',
      columnWithArrow: true,
      toShow: (task) => {
        return task.division;
      },
    },
    {
      columnName: '階',
      isVisible: true,
      width: '6em',
      columnWithArrow: true,
      toShow: (task) => {
        return task.floor;
      },
    },
    {
      columnName: '区画',
      isVisible: true,
      width: '5em',
      columnWithArrow: true,
      toShow: (task) => {
        return task.block;
      },
    },
    {
      columnName: '対象箇所',
      isVisible: true,
      width: '12em',
      columnWithArrow: true,
      toShow: (task) => {
        return task.target;
      },
    },
    {
      columnName: '作業内容',
      isVisible: isWorkChecked,
      width: '12em',
      columnWithArrow: true,
      toShow: (task) => {
        return task.content;
      },
    },
    {
      columnName: '業務データ種別',
      isVisible: true,
      width: '7.5em',
      columnWithArrow: true,
      toShow: (task) => {
        const res = DataType.find(({ key }) => key === task.businessDataType);
        if (res === undefined) {
          return '不明';
        }
        return res.value;
      },
    },
    {
      columnName: '',
      isVisible: true,
      width: '7em',
      columnWithArrow: true,
      toShow: (task) => {
        return task.sections.join(',');
      },
      render: (task) => {
        return (
          <div className={styles.sectionIcons}>
            {task.sections.map((sectionCode) => {
              return <SectionIcon sectionCode={sectionCode} key={sectionCode}/>;
            })}
          </div>
        );
      },
    },
    {
      columnName: '開始',
      isVisible: false,
      width: '5em',
      isDate: true,
      toShow: (task: CustomTask) => {
        return task.start;
      },
    },
    {
      columnName: '終了',
      isVisible: false,
      width: '5em',
      isDate: true,
      toShow: (task: CustomTask) => {
        return task.end;
      },
    },
  ];
}

/**
 * ツールチップ非表示用コンポーネント
 * @constructor
 */
export const NullToolTip: React.FC<{
  task: CustomTask;
  fontSize: string;
  fontFamily: string;
}> = () => {
  return null;
};
